import { useSwalDialog } from '@/use/swalDialog';
import { PartnerCodeName } from '@/models/partner';
import type { CustomLocationType } from '@/models/address';
const { showConfirmPopupDialogWithValidation } = useSwalDialog();

const SENIOR_CENTER = {
  city: 'Union City',
  country: 'US',
  googlePlaceId: 'ChIJ0btZnlCVj4ARKkH4qOFTbS4',
  googlePlaceTypes: 'premise',
  latitude: 37.5990767,
  longitude: -122.0042679,
  name: '34400 Mission Blvd',
  state: 'CA',
  streetAddress: '34400 Mission Boulevard',
  zip: '94587',
};

const SENIOR_CENTER_ENTRANCES = new Map<string, { label: string; point: { lat: number; lng: number } }>([
  [
    'south_mall_entrance',
    {
      label: 'South Mall Entrance',
      point: { lat: 37.59803, lng: -122.005921 },
    },
  ],
  ['adams_entrance', { label: 'Adams Entrance', point: { lat: 37.599578, lng: -122.006714 } }],
  [
    'lorber',
    {
      label: 'Lorber (Skilled Nursing)',
      point: { lat: 37.599641, lng: -122.005723 },
    },
  ],
  [
    'pavillion',
    {
      label: 'Pavillion: 1st fl Memory | 2nd fl Assisted Living',
      point: { lat: 37.598364, lng: -122.004556 },
    },
  ],
]);

export const getSelectedEntranceCoordinates = async (
  partnerCode: string,
  incomingAddress: CustomLocationType,
): Promise<{ lat: number; lng: number } | undefined> => {
  if (partnerCode !== PartnerCodeName.MASONIC) {
    return;
  }

  const isSeniorCenter = incomingAddress.latitude === SENIOR_CENTER.latitude && incomingAddress.longitude === SENIOR_CENTER.longitude;

  if (!isSeniorCenter) {
    return;
  }

  const entranceOptions = Array.from(SENIOR_CENTER_ENTRANCES).reduce(
    (acc, [key, value]) => {
      acc[key] = value.label;
      return acc;
    },
    {} as Record<string, string>,
  );

  const chosenEntrance = await showConfirmPopupDialogWithValidation({
    title: 'Please select the correct entrance from the provided options',
    input: 'radio',
    validationText: 'Please choose one option',
    inputOptions: entranceOptions,
    confirmButtonText: 'Next',
  });

  if (chosenEntrance) {
    return SENIOR_CENTER_ENTRANCES.get(chosenEntrance)?.point;
  }
};
